import SEO from '../components/SEO';
import { PRODUCT_IMAGES } from '../constants';
import { Leaf, Shield, Star } from 'lucide-react';

export default function About() {
  return (
    <main data-testid="about-page" style={{ backgroundColor: '#F7F7F5', minHeight: '100vh' }}>
      <SEO
        title="About RELOAD | Natural Supplement to Increase Semen Volume &amp; Ejaculate More"
        description="Learn how RELOAD's botanical formula helps men increase semen volume, ejaculate more, and boost pre-cum naturally. Science-backed, plant-based male performance supplement."
        canonical="/about"
      />
      {/* Hero */}
      <section style={{ padding: '80px 0', backgroundColor: '#FFFFFF', borderBottom: '1px solid #E2E8F0' }}>
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <span className="overline block mb-4">Our Story</span>
          <h1 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: 'clamp(2rem, 4vw, 3.2rem)', color: '#0D1A2E', letterSpacing: '-0.025em', marginBottom: '22px' }}>
            About RELOAD
          </h1>
          <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '1.05rem', color: '#64748B', lineHeight: 1.85, maxWidth: '560px', margin: '0 auto' }} className="!text-[#64748B]">RELOAD was created for men who refuse to accept declining reproductive performance as inevitable.
We designed a premium plant-based formula to support semen volume, libido, and male reproductive health — naturally.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section style={{ padding: '80px 0' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-14 items-center">
            <div>
              <span className="overline block mb-4">Our Mission</span>
              <h2 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: '2rem', color: '#0D1A2E', marginBottom: '18px', letterSpacing: '-0.025em' }}>
                Built for the Modern Man
              </h2>
              <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.95rem', color: '#64748B', lineHeight: 1.9, marginBottom: '14px' }} className="!text-[#64748B]">Modern life impacts male reproductive health more than ever. Stress, poor diet, and environmental factors can affect libido, semen volume, and overall reproductive performance. RELOAD was created to provide targeted support where modern men need it most.

              </p>
              <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.95rem', color: '#64748B', lineHeight: 1.9, marginBottom: '24px' }}>
                We went back to nature. We studied the botanical ingredients that have been used for centuries in traditional medicine, backed by modern science, and built a formula that&apos;s truly effective.
              </p>
              <div className="blue-divider"></div>
            </div>
            <div className="relative flex justify-center">
              <div style={{ position: 'absolute', width: '280px', height: '280px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(27,61,126,0.06) 0%, transparent 70%)' }} />
              <img src={PRODUCT_IMAGES.floatingBottles} alt="RELOAD Bottles" style={{ maxWidth: '420px', width: '100%', position: 'relative', zIndex: 2, borderRadius: '20px', filter: 'drop-shadow(0 16px 40px rgba(13,26,46,0.12))' }} />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section style={{ padding: '60px 0 96px', backgroundColor: '#FFFFFF' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-center mb-12">
            <h2 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: '2rem', color: '#0D1A2E', letterSpacing: '-0.025em' }}>Our Values</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
            { icon: Leaf, title: 'Natural First', desc: 'We only use plant-based and naturally occurring ingredients. No synthetics, no shortcuts.' },
            { icon: Shield, title: 'Transparent Formula', desc: "Every ingredient is clearly listed. You deserve to know exactly what you're putting into your body." },
            { icon: Star, title: 'Quality Obsessed', desc: 'Manufactured in high-quality facilities. Every batch is produced to the highest standards.' }].
            map(({ icon: Icon, title, desc }) =>
            <div key={title} data-testid={`value-card-${title.toLowerCase().replace(/\s+/g, '-')}`} className="card-light card-hover rounded-2xl p-7">
                <div className="icon-bg-blue mb-5">
                  <Icon size={20} style={{ color: '#1B3D7E' }} strokeWidth={1.5} />
                </div>
                <h3 style={{ fontFamily: 'Outfit, sans-serif', fontSize: '1.05rem', fontWeight: 700, color: '#0D1A2E', marginBottom: '10px' }}>{title}</h3>
                <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.85rem', color: '#64748B', lineHeight: 1.75 }} className="">{desc}</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </main>);

}